















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
// @ts-ignore
import SwaggerUI from '@/components/Documentation/SwaggerUI.vue';

@Component({ name: 'SwaggerFiCustom', components: { SwaggerUI }, metaInfo: { title: 'FI API (Custom)' } })
export default class extends SaascadaVue {

    get url() {
        return process.env.VUE_APP_FI_BASE_URL + '/' + AuthModule.me.institution.code + '-openapi';
    }

}
